import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
const StyledContainer = styled('div')(({ theme, center }) => ({
    display: 'flex',
    marginTop: theme.spacing(3),
    flexDirection: 'column',
    flex: '1 1 auto',
    justifyContent: !center ? 'flex-end' : 'center',
    alignItems: !center ? '' : 'center',
    minHeight: theme.spacing(5),
    '& button': {
        width: '100%',
        marginBottom: theme.spacing(3),
    },
    '& button:last-child': {
        marginBottom: 0,
    },
}));
const ButtonContainer = ({ children, center = false }) => {
    return _jsx(StyledContainer, { children: children, center: +!!center });
};
export default ButtonContainer;
//# sourceMappingURL=index.js.map